<template>
  <div>
    <div class="px">
      <div class="px__body">
        <div class="px__body__cut"></div>
        <div class="px__body__speaker"></div>
        <div class="px__body__sensor"></div>

        <div class="px__body__mute"></div>
        <div class="px__body__up"></div>
        <div class="px__body__down"></div>
        <div class="px__body__right"></div>
      </div>

      <div class="px__screen">
        <div class="px__screen__">
          <div class="px__screen__frame">
            <div class="notch-padding"></div>
            <img :src="image" width="100%" class="mb-0 pb-0" />
            <div class="message-holder scroller mt-0 pt-0">
              <chat :messages="messages" />
            </div>
            <div style="width:100%;height:8%;" class="bottom-bar"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- f9f9f9 -->
</template>

<script>
import chat from "./chat-bubble";
export default {
  components: {
    chat
  },
  props: {
    messages: {
      type: Array
    }
  },
  data: () => ({
    image: require("@/assets/imgs/phone-header.png")
  })
};
</script>
<style scoped src="@/assets/css/devices.min.css"></style>
<style scoped>
.scroller {
  overflow-y: scroll;
  scrollbar-color: #c2c9d2 white;
  scrollbar-width: thin;
}
.px__screen__frame {
  background-color: rgb(255, 255, 255);
}
.message-holder {
  height: 80%;
  overflow-y: auto;
}
.notch-padding {
  height: 4%;
  background-color: #f3f3f2;
  /* background-color: black */
}
.bottom-bar {
  background-color: #f3f3f2;
}
</style>
